import React from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { Shell } from "../components/Shell";
import { Check } from "lucide-react";

export default function Pricing() {
    const { t, user, config } = useApp();
    const nav = useNavigate();
    const price = config?.price || 299;
    return (
        <Shell eyebrow={t("nav.pricing")} title="One honest price. No subscription." intro="WHY-AM is a single one-time payment. We don't show fake discounts, countdowns or invented reviews." max="max-w-3xl">
            <div className="card-soft p-8 lg:p-10">
                <div className="flex items-end gap-2">
                    <span className="text-6xl font-serif text-forest">₹{price}</span>
                    <span className="text-charcoal/60 mb-2">one-time</span>
                </div>
                <ul className="mt-7 space-y-3 text-charcoal/80">
                    {["4 free questions + free preview before you pay anything", "All 18 reflection questions", "Full personalized report, saved to your account", "Unlimited AI companion conversations", "Optional, user-controlled memory and reflections", "Manual human verification of every payment"].map((x) => (
                        <li key={x} className="flex items-start gap-3"><Check size={18} className="text-forest mt-0.5 shrink-0" />{x}</li>
                    ))}
                </ul>
                <button data-testid="pricing-cta" onClick={() => nav(user ? "/assessment" : "/onboarding")} className="btn-primary w-full mt-8 py-3.5 font-medium">{t("nav.start")}</button>
            </div>
            <div className="mt-8 card-soft p-6 bg-forest/5 text-sm text-charcoal/75 leading-relaxed">
                <strong className="text-forest">How payment works:</strong> you pay via the method shown at checkout and submit your transaction reference. Your access stays pending until the owner independently confirms the payment was received and approves it. A screenshot is never treated as proof. See our <button onClick={() => nav("/refund")} className="underline text-forest">Refund & Cancellation Policy</button>.
            </div>
        </Shell>
    );
}
